// extracted by mini-css-extract-plugin
module.exports = {"container":"container--f8146","withPlaceHolder":"withPlaceHolder--9ce7c"};